import DefaultLayout from "@/layouts/DefaultLayout/DefaultLayout.vue"
import authRoutes from "./modules/auth"
import commonRoutes from "./modules/common"
import dataManage from "./modules/dataManage"
import audiencesRoutes from "./modules/audiences"
import accountManageRoutes from "./modules/accountManage"
import automatedMarketingRoutes from "./modules/automatedMarketing"
import marketing from "./modules/marketing"
import marketingResources from "./modules/marketingResources"
import platformSettings from "./modules/platformSettings"
import notificationCenter from "./modules/notificationCenter"

const routes = [
    {
        path: "/",
        name: "home",
        meta: {
            requiresAuth: true,
        },
    },
    ...authRoutes,
    ...commonRoutes,
    ...dataManage,
    ...audiencesRoutes,
    ...automatedMarketingRoutes,
    ...marketing,
    ...marketingResources,
    ...accountManageRoutes,
    ...platformSettings,
    ...notificationCenter,
    {
        path: "/about",
        name: "About",
        component: () => import("@/pages/About.vue"),
    },
    {
        path: "/redirect/:id",
        name: "redirect",
        component: DefaultLayout,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "",
                component: () => import("@/pages/RedirectPage.vue"),
                name: "redirect-index",
            },
        ],
    },
    {
        path: "/forbidden",
        name: "forbidden",
        component: DefaultLayout,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "",
                component: () => import("@/pages/ForbiddenPage.vue"),
                name: "forbidden-index",
            },
        ],
    },
    {
        path: "/:pathMatch(.*)*",
        component: DefaultLayout,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "",
                component: () => import("@/pages/NotFoundPage.vue"),
                name: "not-found",
            },
        ],
    },
]

export default routes
